import React, { Component } from "react";
import AdminForm from "./AdminForm";
import AdminUpdateForm from "./AdminUpdateForm";
import AdminPasswordForm from "./AdminPasswordForm";
import ContentHeader from "./ContentHeader";
import { get, create, update, changeAdminPassword } from "../actions";
import { connect } from "react-redux";
import InvalidAccessView from "./InvalidAccessView";

class Admin extends Component {
  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.fetchAdmin(this.props.match.params.id);
    }
  }

  userNotAllowed() {
    const allowedRoles = ["super_admin"];
    return !allowedRoles.includes(this.props.currentUserRole);
  }

  render() {
    if (this.userNotAllowed()) {
      return <InvalidAccessView />;
    }

    //proceed after asserting user is valid
    let { admin, saveAdmin } = this.props;
    const renderMode = !!this.props.match.params.id ? "Edit" : "Add";
    let mode = `${renderMode} admin`;

    let view = (
      <AdminForm admin={admin} saveAdmin={saveAdmin} {...this.props} />
    );
    if (this.props.match.path.includes("edit")) {
      view = (
        <AdminUpdateForm admin={admin} saveAdmin={saveAdmin} {...this.props} />
      );
    }

    if (this.props.match.path.includes("password")) {
      mode = "Change password";
      view = (
        <AdminPasswordForm
          admin={admin}
          saveAdmin={saveAdmin}
          {...this.props}
        />
      );
    }
    return (
      <div>
        <ContentHeader title={mode} />
        {view}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admins.currentAdmin || {},
    currentUserRole: state.app.role
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAdmin(id) {
      dispatch(get("admin", id));
    },
    saveAdmin(data, mode) {
      if (data.id) {
        if (mode === "password") {
          dispatch(changeAdminPassword(data));
        } else {
          dispatch(update("admin", data));
        }
      } else {
        dispatch(create("admin", data));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js